"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmeraldSnackbarData = void 0;
const toast_inputs_1 = require("../toast/toast.inputs");
const snackbar_position_1 = require("./snackbar.position");
const snackbar_variance_1 = require("./snackbar.variance");
class EmeraldSnackbarData {
    constructor(message, containerId = toast_inputs_1.DefaultContainerID) {
        this.message = message;
        this.containerId = containerId;
        this.variance = snackbar_variance_1.EmeraldSnackbarVariance.NONE;
        this.position = snackbar_position_1.EmeraldSnakbarPosition.NONE;
        this.hasDismissIcon = false;
        this.hasActionButton = false;
        this.actionButtonText = 'Ok';
        this.showSecondaryButton = false;
        this.secondaryButtonText = '';
        this.timeoutMs = 5000;
        this.isStacked = false;
        this.closeOnEscape = false;
    }
}
exports.EmeraldSnackbarData = EmeraldSnackbarData;
//# sourceMappingURL=snackbar.inputs.js.map